import React from "react";
import { FaGoogle, FaGithub, FaLinkedin } from "react-icons/fa";
 import { FcGoogle } from "react-icons/fc";
/*
  Buttons show only icons in a horizontal row.
  Clicking redirects to provider login/home pages.
  You can replace URLs with proper OAuth authorize endpoints when ready.
*/
export default function SocialIcons(){
    const bg = { google: '#ffffff', github: '#111111', linkedin: '#0077B5' };
  const providers = [
    { name: 'google', url: 'https://accounts.google.com/signin', icon: <FcGoogle size={22} color='#000'/> },
    { name: 'github', url: 'https://github.com/login', icon: <FaGithub size={22} color='#fff'/> },
    { name: 'linkedin', url: 'https://www.linkedin.com/login', icon: <FaLinkedin size={22} color='#fff'/> }
  ];

  return (
    <div style={{display:'flex', justifyContent:'center', gap:'12px', marginTop:18}}>
      {providers.map(p => (
        <a key={p.name} href={p.url} target="_blank" rel="noreferrer"
           className={'social-icon ' + p.name} title={p.name}>
          {p.icon}
        </a>
      ))}
    </div>
  );
}
